(function importImagesProcessControllerDefinition() {
    'use strict';

    angular.module('ImportImagesProcess')
        .controller('ImportImagesProcessAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importImagesProcessService', '$stateParams', 'authExtend', 'alerts', 'documentTypeService','fileService',
            function importImagesProcessController($scope, config, $state, $translate, errors, importImagesProcessService, $stateParams, authExtend, alerts, documentTypeService, fileService) {
        $scope.optionsDocumentTypes = [];
        $scope.process = {};

        $scope.aux = {
            files: [],
            filesTemp: []
        };

        $scope.load = function () {
            

            documentTypeService.getFunctionsTypes(['IMPORT IMAGES PROCESS WRITE']).then(function (result) {
                $scope.optionsDocumentTypes = result;
            }, function (error) {
                errors.showError(error);
                $scope.cancel();
            });
        }

        $scope.cancel = function () {
            $state.goBack('import-images-process-find');
        };

                $scope.addFile = function () {
            $scope.aux.filesTemp.forEach(function (file) {
                if (file && file.size) {
                    file.fsize = fileService.FormatfileSize(file.size);
                    var index = $scope.getIndexFile(file);
                    if (~index) {
                        $scope.aux.files[index] = file;
                    } else {
                        $scope.aux.files = [];
                        $scope.aux.files.push(file);
                    }
                }
            });
                
            $scope.process.name = $scope.aux.filesTemp[0].name;
            $scope.aux.filesTemp = [];
        };

        $scope.getIndexFile = function (fileNew) {

            for (var i in $scope.aux.files) {
                if ($scope.aux.files.hasOwnProperty(i)) {
                    var fileOld = $scope.aux.files[i];

                    if (fileOld.name === fileNew.name) {
                        return i;
                    }
                }
            };

            return -1;
        };

        $scope.removeFile = function (file) {
            var index = $scope.getIndexFile(file);

            if (~index) {
                $scope.aux.files.splice(index, 1);
            }
        };

    
        $scope.save = function () {
            
            var msj = '';
            if (!$scope.importForm.$valid) {
                $scope.importForm.$setSubmitted();
                errors.showError('VerifyFormData');
                return;
            }
            
            if ($scope.process.organizationalUnit) {
                $scope.process.organizationalUnitId = $scope.process.organizationalUnit.id;
                $scope.process.organizationalUnitName = $scope.process.organizationalUnit.Name;
            }
                        
            return importImagesProcessService.create($scope.process, $scope.aux.files).then(function () {
                $state.go('import-images-process-find');
            }, function (error) {
                errors.showError(error);
            });
        };

      
        $scope.load();
    }
        ]);
})();